import { ErrorBoundary } from '@/pages/org-chart/user/org-chart.error';

export default ErrorBoundary;
